//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { postAction } from '@/api/manage';
import PDFModal from '@comp/PDFView/PDFModal';
import VideoModel from "../../components/VideoMode/VideoModel";
export default {
  name: 'FullFileSearch',
  data: function data() {
    return {
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      searchtext: "",
      size: 10,
      page: 1,
      total: 0,
      doclist: [],
      url: "/sys/search/file"
    };
  },
  components: {
    PDFModal: PDFModal
  },
  methods: {
    /* 文件下载 */
    downUploadFile: function downUploadFile(text) {
      if (!text) {
        this.$message.warning("未知的文件");
        return;
      }

      window.open(window._CONFIG['domianURL'] + "/sys/common/file/download/" + text);
    },
    onShowSizeChange: function onShowSizeChange(current, pageSize) {
      this.page = current;
      this.size = pageSize;
      this.searchQuery();
    },
    searchQuery: function searchQuery() {
      var _this = this;

      var params = {
        text: this.searchtext,
        size: this.size,
        page: this.page
      };
      postAction(this.url, params).then(function (res) {
        if (res.success) {
          if (res.result) {
            _this.page = res.result.page;
            _this.total = res.result.totalRecord;

            if (res.result.docList && res.result.docList.length > 0) {
              _this.doclist = res.result.docList;
            } else {
              _this.doclist = [];

              _this.$message.info("未检索到对应文件!");
            }
          }
        } else {
          _this.$message.error(res.message);
        }
      });
    }
  }
};